const reportDB = require("../../../../../components/report/report-db");
const style = require('../../../../../components/report/report-style')
const css = style.getCliente()

export function start(detail) {

  const phpFile = 'server/php/sql/report.php'
  detail.inf = { entity: 'clientActivity', report: 'clientActivity-customer-report' }

  reportDB.select(detail, phpFile, (data) => {

    const body = generate(data)
    showReport(body);
  })

}/**/

function showReport(body) {
  let iframe = document.getElementById("reportIframe");
  iframe.src = 'about:blank';

  const doc = iframe.contentWindow.document;

  doc.open();
  doc.write(
    "<!DOCTYPE html><html><head></head><body>" + body + "</body></html>"
  );
  doc.close();
  iframe.contentWindow.print();
  iframe.onload = null;

}

function generate(data) {
  var body = "";
  // body += generateHeader();
  body += generateTop(data[0]);
  body += generateTable(data);
  body += `</div> <!-- dataCont -->`;
  body += `<div class="report-page">`;

  return body;
}

function generateTop(data) {
  return `
    <div ${css.title}>${data.company_name}</div>
    <div ${css.subtitle}>Payable All Report As Of ${data.current_dateTime}</div>
  `;
}

function generateTable(data) {
  var totals = {
    current: 0,
    total_due_30_days: 0,
    total_due_31_to_60_days: 0,
    total_due_61_to_90_days: 0,
    total_due_over_90_days: 0,
    grandTotal: 0,
  };

  var table = `
    <div ${css.paragraph}>
      This report details your outstanding sales invoices with our company.
      It shows a list of upcoming and past-due balances.
      Use it to plan and manage your payments effectively.
    </div>

    <table ${css.table} class="dt-alterColor">
      <tr>
        <th ${css.th}>Invoice</th>
        <th ${css.th}>Current</th>
        <th ${css.th}>30 days</th>
        <th ${css.th}>31 to 60 days</th>
        <th ${css.th}>61 to 90 days</th>
        <th ${css.th}>Over 90 days</th>
        <th ${css.th}>Total</th>
      </tr>
  `;

  for (let i = 0; i < data.length; i++) {
    let rowTotal = 0;

    const current = parseFloat(data[i].current.replace(/[$,]/g, ""));
    const d30 = parseFloat(data[i].total_due_30_days.replace(/[$,]/g, ""));
    const d31 = parseFloat(data[i].total_due_31_to_60_days.replace(/[$,]/g, ""));
    const d61 = parseFloat(data[i].total_due_61_to_90_days.replace(/[$,]/g, ""));
    const d90 = parseFloat(data[i].total_due_over_90_days.replace(/[$,]/g, ""));

    totals.current += current;
    totals.total_due_30_days += d30;
    totals.total_due_31_to_60_days += d31;
    totals.total_due_61_to_90_days += d61;
    totals.total_due_over_90_days += d90;

    rowTotal = current + d30 + d31 + d61 + d90;

    table += `
      <tr ${rowStyle(i)}>
        <td ${css.td}>${data[i].code}</td>
        <td ${css.td}>${cashVal(data[i].current)}</td>
        <td ${css.td}>${cashVal(data[i].total_due_30_days)}</td>
        <td ${css.td}>${cashVal(data[i].total_due_31_to_60_days)}</td>
        <td ${css.td}>${cashVal(data[i].total_due_61_to_90_days)}</td>
        <td ${css.td}>${cashVal(data[i].total_due_over_90_days)}</td>
        <td ${css.td}>${cashVal(rowTotal)}</td>
      </tr>
    `;
  }

  // GRAND TOTAL
  totals.grandTotal =
    totals.current +
    totals.total_due_30_days +
    totals.total_due_31_to_60_days +
    totals.total_due_61_to_90_days +
    totals.total_due_over_90_days;

  // FILA DE TOTALES
  table += `
    <tr>
      <td ${css.totalLabel}>Total</td>
      <td ${css.totalCell}>${cashVal(totals.current)}</td>
      <td ${css.totalCell}>${cashVal(totals.total_due_30_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.total_due_31_to_60_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.total_due_61_to_90_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.total_due_over_90_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.grandTotal)}</td>
    </tr>
  `;

  table += `</table>`;
  return table;
}


function cashVal(value) {
  return value.toLocaleString("en-US", { style: "currency", currency: "USD" });
}

function rowStyle(i) {
  if (i % 2 === 0) {
    return "";
  }
  return css.trGray;
}